import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";
import { StudySummary } from "../../../../../app/Dermicus/Studies/StudySummary";
import { StudyResultParticipantSummary } from "../../../../../app/Dermicus/Studies/StudyResultParticipantSummary";
import { StudyExaminationSummary } from "../../../../../app/Dermicus/Studies/StudyExaminationSummary";

export function userStudiesAsAdminGet(userId: number) {
  return practitionerHttpService
    .get<StudySummary[]>(`/api/internal/users/${userId}/studies/as-admin`)
    .then((response) => response.data);
}

export function userStudiesAsParticipantGet(userId: number) {
  return practitionerHttpService
    .get<StudySummary[]>(`/api/internal/users/${userId}/studies/as-participant`)
    .then((response) => response.data);
}

export function userStudyResultsGet(userId: number, studyId?: number) {
  return practitionerHttpService
    .get<
      StudyResultParticipantSummary[]
    >(`/api/internal/users/${userId}/study-results`, { params: { studyId } })
    .then((response) => response.data);
}

export function userStudyResultGet(
  userId: number,
  studyExaminationId: number,
  params?: { refresh?: boolean },
) {
  return practitionerHttpService
    .get<{
      workflow_definition: Record<string, unknown>;
      study_examination: Record<string, unknown>;
    }>(`/api/internal/users/${userId}/study-results/${studyExaminationId}`, {
      params,
    })
    .then((response) => response.data);
}

export function userStudyExaminationsGet(userId: number, studyId?: number) {
  return practitionerHttpService
    .get<
      StudyExaminationSummary[]
    >(`/api/internal/users/${userId}/study-examinations`, { params: { studyId } })
    .then((response) => response.data);
}

export function userPrimaryCenterUpdate(
  userId: number,
  centerId: number,
  keepExternalAccess: boolean,
) {
  return practitionerHttpService.put(
    `/api/internal/users/${userId}/center-connections/primary/${centerId}`,
    { keepExternalAccess: keepExternalAccess.valueOf() },
  );
}

export interface CenterConnection {
  center: { id: number; name: string };
  is_editable: boolean;
}

export interface UserCenterConnections {
  // Null when the user has no primary centre, or when it has been deactivated.
  primary: CenterConnection | null;
  connected: CenterConnection[];
}

export function userConnectedCentersGet(userId: number | string) {
  return practitionerHttpService
    .get<UserCenterConnections>(
      `/api/internal/users/${userId}/center-connections`,
    )
    .then((response) => response.data);
}

export interface ConnectedCenterInput {
  center_id: number;
  is_editable: boolean;
}

export function userConnectedCentersSync(
  userId: number | string,
  centers: ConnectedCenterInput[],
  regionId: number | string | null,
) {
  return practitionerHttpService.put(
    `/api/internal/users/${userId}/center-connections/connected`,
    { centers, region_id: regionId },
  );
}
